import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CheckCircle2, ChevronLeft, MapPin, Calendar, CheckSquare, X } from 'lucide-react';
import { Crown } from 'lucide-react';

export default function ValidarScreen() {
  const [loading, setLoading] = useState(true);

  const searchParams = new URLSearchParams(window.location.search);
  const placa = searchParams.get('placa') || 'N/A';
  const serial = searchParams.get('serial') || 'N/A';
  const fechaGeneracion = new Date().toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' });

  useEffect(() => {
    // Simular un pequeño retardo de conexión para dar sensación de verificación real con base de datos
    const tm = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(tm);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-start text-white relative overflow-hidden font-sans">
      {/* Cintas decorativas y gradientes */}
      <div className="absolute top-0 w-full h-1 bg-gradient-to-r from-yellow-400 via-yellow-600 to-yellow-400 z-10"></div>
      <div className="absolute -top-[10%] -left-[10%] w-[120%] h-[40%] bg-gradient-to-b from-yellow-500/10 to-transparent rounded-full blur-3xl pointer-events-none"></div>
      
      <header className="w-full flex items-center justify-between p-4 z-10">
         <div className="w-9 h-9"></div> {/* Espaciador izquierdo */}
         <h1 className="text-yellow-500 font-black tracking-widest text-[11px] uppercase">Agencia Nacional MotoPikis</h1>
         <button onClick={() => window.location.href = '/motopikispro/'} className="p-2 bg-white/5 rounded-full hover:bg-white/10 text-white transition-colors">
            <X className="w-5 h-5 text-white/70" />
         </button>
      </header>

      {loading ? (
        <div className="flex-1 flex flex-col items-center justify-center -mt-10 z-10">
          <div className="w-16 h-16 border-4 border-yellow-500/20 border-t-yellow-500 rounded-full animate-spin mb-6"></div>
          <p className="text-slate-400 font-bold uppercase tracking-widest text-[11px] animate-pulse">Contactando matriz de verificación...</p>
        </div>
      ) : (
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} className="flex-1 w-full max-w-sm px-4 pt-4 pb-12 flex flex-col items-center z-10">
          
          <div className="mb-6 relative">
             <div className="absolute inset-0 bg-yellow-500/30 blur-2xl rounded-full"></div>
             <Crown className="w-20 h-20 text-yellow-500 drop-shadow-[0_0_15px_rgba(234,179,8,0.5)] relative z-10" />
          </div>

          <h2 className="text-2xl font-black uppercase tracking-widest text-center mb-1 text-white drop-shadow-md">
            Vehículo
            <br/>
            Certificado
          </h2>
          <div className="bg-green-500/20 border border-green-500/30 rounded-full px-4 py-1.5 flex items-center gap-2 mb-8">
            <CheckCircle2 className="w-4 h-4 text-green-400" />
            <span className="text-green-400 text-[11px] font-black uppercase tracking-widest">Estado: 100% Legal Al Día</span>
          </div>

          <div className="w-full bg-[#1e293b]/50 border border-white/5 rounded-3xl p-6 shadow-xl backdrop-blur-md">
            
            <div className="flex flex-col items-center border-b border-white/10 pb-5 mb-5">
              <span className="text-slate-400 text-[10px] font-bold uppercase tracking-widest mb-1">Matrícula Validada</span>
              <div className="bg-gradient-to-r from-yellow-300 to-yellow-500 px-6 py-2 rounded-lg shadow-inner ring-2 ring-yellow-600/50">
                 <span className="text-black font-black text-2xl tracking-[0.2em]">{placa}</span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
               <div className="flex flex-col">
                  <span className="text-slate-500 text-[9px] font-black uppercase tracking-widest mb-0.5">Membresía</span>
                  <span className="text-yellow-400 text-[12px] font-bold flex items-center gap-1"><Crown className="w-3 h-3"/> ORO ACTIVA</span>
               </div>
               <div className="flex flex-col">
                  <span className="text-slate-500 text-[9px] font-black uppercase tracking-widest mb-0.5">Fecha Check</span>
                  <span className="text-white text-[12px] font-bold">{fechaGeneracion}</span>
               </div>
               <div className="flex flex-col col-span-2">
                  <span className="text-slate-500 text-[9px] font-black uppercase tracking-widest mb-0.5">Hash de Autenticidad (SHA)</span>
                  <span className="text-slate-300 font-mono text-[10px] bg-black/40 px-2 py-1.5 rounded border border-white/5 truncate">{serial}</span>
               </div>
            </div>

            <div className="mt-5 p-3 bg-blue-500/10 border border-blue-500/20 rounded-xl flex gap-3 items-start">
               <ShieldCheck className="w-6 h-6 text-blue-400 shrink-0" />
               <p className="text-slate-300 text-[10px] leading-relaxed">
                 Este documento digital es inviolable. Verifica que el serial en pantalla coincida con el dictaminado en el dispositivo del Motero. Vehículo blindado legalmente por MotoPikis.
               </p>
            </div>
          </div>

        </motion.div>
      )}
    </div>
  );
}
